import { render, staticRenderFns } from "./ContentAngebote.vue?vue&type=template&id=48dae7c8&"
import script from "./ContentAngebote.vue?vue&type=script&lang=js&"
export * from "./ContentAngebote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports